import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function Modal({ isOpen, onClose, children }: ModalProps) {
  if (!isOpen) return null;

  return (
    <>
      {/* Transparent overlay */}
      <div className="fixed inset-0 z-50" onClick={onClose} />
      
      {/* Modal content */}
      <div className="fixed inset-0 flex justify-center items-center z-50 pointer-events-none">
        <div 
          className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto pointer-events-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </>
  );
} 